var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { TimeGaugeRaw } from './time-gauge-raw';
import { TimeGaugeRawCadenced } from './time-gauge-raw-cadenced';
var height = 4;
var tockSpacing = 2;
var tockMaxWidth = 12;
var tickSpacing = 1;
var tickMaxWidth = Math.floor(tockMaxWidth * (3 / 5));
var styleProps = {
    height: height,
    tockMaxWidth: tockMaxWidth,
    tockSpacing: tockSpacing,
    tickMaxWidth: tickMaxWidth,
    tickSpacing: tickSpacing
};
export var TimeGauge = function (_a) {
    var startTime = _a.startTime, duration = _a.duration;
    return (startTime
        ? React.createElement(TimeGaugeRawCadenced, __assign({}, styleProps, { startTime: startTime, duration: duration }))
        : React.createElement(TimeGaugeRaw, __assign({}, styleProps, { duration: duration })));
};
